import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-e29b8b924f/0/cache/next-npm-14.2.25-cd023f1b24-fa0cd12ba7.zip/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Match"] */ "/app/webapp/app/pwa/components/match/Match.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoundSelect"] */ "/app/webapp/app/pwa/components/round/RoundSelect.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/branding/kicker-icon-sm.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/default_team_logo.png");
